import {
  ActionIcon,
  Box,
  Container,
  Divider,
  Flex,
  Grid,
  Text,
  useMantineTheme,
} from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { api } from '../services/master.service';
import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandTwitter,
  IconCategory,
} from '@tabler/icons-react';
import { IconX } from '@tabler/icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useMediaQuery } from '@mantine/hooks';
import { contact_address, branch_address, contact_email, contact_phone, footer_bg_shade, is_mobile_view, link_facebook, link_instagram, link_twitter, logo_name } from '../config';
import leftPlaceholder from "../static/images/left.jpg";
import rightPlaceholder from "../static/images/right.jpg";

function AppFooter() {
  //  const leftPlaceholder = process.env.PUBLIC_URL + "/static/images/left.jpg";
  // const rightPlaceholder = process.env.PUBLIC_URL + "/static/images/right.jpg";

  const [logo, setLogo] = useState('');
  useEffect(() => {
    import(`../static/images/${logo_name}`).then((module) => {
      setLogo(module.default);
    });
  }, [])
  const navigate = useNavigate();
  let isMobileScreen = useMediaQuery('(max-width: 768px)');
  isMobileScreen = is_mobile_view ? is_mobile_view : isMobileScreen;
  const theme = useMantineTheme();
  const location = useLocation();

  const [categories, setCategories] = useState([]);
  useEffect(() => {
    api.get_categories().then((res) => {
      console.log(res.data.data);
      let filtered_categories = res.data.data.filter((e) => e.sub_category.length > 1);
      setCategories(filtered_categories);
    });
  }, []);

  const [hoveredLeftCategory, setHoveredLeftCategory] = useState(null);
  const [hoveredRightCategory, setHoveredRightCategory] = useState(null);
  return (
    <div
      style={{
        background: '#eee',
        marginTop: isMobileScreen ? 0 : 20,
      }}
    >
      {!isMobileScreen && categories.length > 0 && (
        <Container size="xl">
          <Box py={30} px={18}>
            <Text
              size="xl"
              fw={400}
              mb={30}
              align="center"
              style={{
                color: theme.colors.brand[8],
                fontSize: "28px",
                fontWeight: "bold",
              }}
            >
              Our Range of Products
            </Text>

            {/* === CENTERED MAIN CATEGORY BOX === */}
            <Box
              style={{
                width: "480px", // ✅ slightly smaller width
                height: "520px", // ✅ more height, no scroll
                margin: "0 auto", // ✅ centered in page
                padding: 0,
                backgroundColor: "#fff",
                boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                borderRadius: "8px",
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                position: "relative",
                overflow: "visible", // ✅ prevents clipping
              }}
            >
              {/* === LEFT CATEGORY COLUMN === */}
              <div
                style={{
                  padding: "16px",
                  borderRight: "1px solid #eee",
                  background: "#fff",
                }}
              >
                {categories.slice(0, Math.ceil(categories.length / 2)).map((cat) => (
                  <div
                    key={cat.id}
                    onMouseEnter={() => {
                      setHoveredLeftCategory(cat);
                      setHoveredRightCategory(null);
                    }}
                    onClick={() => {
                      if (cat.id === 41 || cat.title === "Bundles") {
                        navigate("/bundles");
                      } else {
                        navigate(`/category/?id=${cat.id}`);
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      fontSize: "15px",
                      fontWeight: "bold",
                      padding: "6px 10px",
                      borderRadius: "4px",
                      marginBottom: "4px",
                      background:
                        hoveredLeftCategory?.id === cat.id ? "#e9f6f0ff" : "transparent",
                      color: hoveredLeftCategory?.id === cat.id ? "theme.colors.brand[9]" : " theme.colors.brand[9]",
                      transition: "background 0.2s",
                    }}
                  >
                    {cat.title}
                  </div>
                ))}

                {/* === LEFT SUBCATEGORY LIST === */}

                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    right: "100%",
                    width: "440px",
                    height: "520px", // ✅ match main box height
                    background: "#f6fcf8",
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px 0 0 8px",
                    padding: "16px",
                    boxShadow: "-4px 4px 12px rgba(0,0,0,0.05)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: hoveredLeftCategory ? "flex-start" : "center",
                    alignItems: hoveredLeftCategory ? "stretch" : "center",
                    transform: "translateX(-12px)",
                    zIndex: 5,
                    overflow: "hidden",
                  }}
                >
                  {hoveredLeftCategory ? (
                    <>
                      <div
                        style={{
                          fontWeight: "bold",
                          marginBottom: "10px",
                          color: "#0b8457",
                        }}
                      >
                        {hoveredLeftCategory.title}
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            hoveredLeftCategory.sub_category?.length > 12
                              ? "repeat(3, 1fr)"
                              : hoveredLeftCategory.sub_category?.length > 6
                                ? "repeat(2, 1fr)"
                                : "repeat(1, 1fr)",
                          gap: "8px 16px",
                          alignItems: "start",
                        }}
                      >
                        {hoveredLeftCategory.sub_category?.map((sub) => (
                          <div
                            key={sub.id}
                            onClick={() =>
                              navigate(
                                `/category/?id=${hoveredLeftCategory.id}&subcategory=${sub.id}`
                              )
                            }
                            style={{
                              cursor: "pointer",
                              fontSize: "14px",
                              fontWeight: "bold",
                              padding: "5px 8px",
                              borderRadius: "4px",
                              transition: "background 0.2s",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.background = "#e9f6f0")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.background = "transparent")
                            }
                          >
                            {sub.title}
                          </div>
                        ))}
                      </div>

                      {hoveredLeftCategory.sub_category?.length > 0 && (
                        <div
                          onClick={() => {
                            if (hoveredLeftCategory.id === 41 || hoveredLeftCategory.title === "Bundles") {
                              navigate("/bundles");
                            } else {
                              navigate(`/category/?id=${hoveredLeftCategory.id}`);
                            }
                          }}
                          style={{
                            marginTop: "12px",
                            fontWeight: "600",
                            color: "#0b8457",
                            cursor: "pointer",
                          }}
                        >
                          View all in {hoveredLeftCategory.title} →
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url(${leftPlaceholder})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        opacity: 0.9,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "8px",
                        transition: "0.3s ease",
                      }}
                    >
                      <Text
                        style={{
                          background: "rgb(255 255 255 / 93%)",
                          padding: "8px 12px",
                          borderRadius: "6px",
                          fontWeight: "bold",
                        }}
                      >
                        Hover Category →
                      </Text>
                    </div>
                  )}
                </div>
              </div>

              {/* === RIGHT CATEGORY COLUMN === */}
              <div
                style={{
                  padding: "16px",
                  borderLeft: "1px solid #eee",
                  background: "#fff",
                }}
              >
                {categories.slice(Math.ceil(categories.length / 2)).map((cat) => (
                  <div
                    key={cat.id}
                    onMouseEnter={() => {
                      setHoveredRightCategory(cat);
                      setHoveredLeftCategory(null);
                    }}
                    onClick={() => {
                      if (cat.id === 41 || cat.title === "Bundles") {
                        navigate("/bundles");
                      } else {
                        navigate(`/category/?id=${cat.id}`);
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      fontSize: "15px",
                      fontWeight: "bold",
                      padding: "6px 10px",
                      borderRadius: "4px",
                      marginBottom: "4px",
                      background:
                        hoveredRightCategory?.id === cat.id ? "#e9f6f0" : "transparent",
                      color: hoveredRightCategory?.id === cat.id ? "theme.colors.brand[9]" : " theme.colors.brand[9]",
                      transition: "background 0.2s",
                    }}
                  >
                    {cat.title}
                  </div>
                ))}

                {/* === RIGHT SUBCATEGORY LIST === */}

                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: "100%",
                    width: "440px",
                    height: "520px", // ✅ match main height
                    background: "#f6fcf8",
                    border: "1px solid #e0e0e0",
                    borderRadius: "0 8px 8px 0",
                    padding: "16px",
                    boxShadow: "4px 4px 12px rgba(0,0,0,0.05)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: hoveredRightCategory ? "flex-start" : "center",
                    alignItems: hoveredRightCategory ? "stretch" : "center",
                    transform: "translateX(12px)",
                    zIndex: 5,
                    overflow: "hidden",
                  }}
                >
                  {hoveredRightCategory ? (
                    <>
                      <div
                        style={{
                          fontWeight: "bold",
                          marginBottom: "10px",
                          color: "#0b8457",
                        }}
                      >
                        {hoveredRightCategory.title}
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            hoveredRightCategory.sub_category?.length > 12
                              ? "repeat(3, 1fr)"
                              : hoveredRightCategory.sub_category?.length > 6
                                ? "repeat(2, 1fr)"
                                : "repeat(1, 1fr)",
                          gap: "8px 16px",
                          alignItems: "start",
                        }}
                      >
                        {hoveredRightCategory.sub_category?.map((sub) => (
                          <div
                            key={sub.id}
                            onClick={() =>
                              navigate(
                                `/category/?id=${hoveredRightCategory.id}&subcategory=${sub.id}`
                              )
                            }
                            style={{
                              cursor: "pointer",
                              fontSize: "14px",
                              fontWeight: "bold",
                              padding: "5px 8px",
                              borderRadius: "4px",
                              transition: "background 0.2s",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.background = "#e9f6f0")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.background = "transparent")
                            }
                          >
                            {sub.title}
                          </div>
                        ))}
                      </div>

                      {hoveredRightCategory.sub_category?.length > 0 && (
                        <div
                          onClick={() => {
                            if (hoveredRightCategory.id === 41 || hoveredRightCategory.title === "Bundles") {
                              navigate("/bundles");
                            } else {
                              navigate(`/category/?id=${hoveredRightCategory.id}`);
                            }
                          }}
                          style={{
                            marginTop: "12px",
                            fontWeight: "600",
                            color: "#0b8457",
                            cursor: "pointer",
                          }}
                        >
                          View all in {hoveredRightCategory.title} →
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url(${rightPlaceholder})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        opacity: 0.9,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "8px",
                        transition: "0.3s ease",
                      }}
                    >
                      <Text
                        style={{
                          background: "rgb(255 255 255 / 93%)",
                          padding: "8px 12px",
                          borderRadius: "6px",
                          fontWeight: "bold",
                        }}
                      >
                        ← Hover Category
                      </Text>
                    </div>
                  )}
                </div>
              </div>
            </Box>
          </Box>
        </Container>
      )}
      <footer
        style={{
          background: theme.colors.brand[footer_bg_shade],
        }}
      >
        <Container size={'xl'} py={30}>
          <Box p={20}>
            <Grid gutter={'xl'}>
              <Grid.Col span={12} md={3} lg={3}>
                <img
                  src={logo}
                  width={'60%'}
                  height={57}
                  alt=""
                  style={{
                    objectFit: 'cover',
                  }}
                />
              </Grid.Col>
              <Grid.Col span={6} md={3} lg={3}>
                <Box
                  style={{
                    borderBottom: '1px solid rgba(238, 238, 238, 0.2)',
                  }}
                  pb={10}
                >
                  <Text color="#565656" fw={600} size={14}>
                    Contact Info
                  </Text>
                </Box>
                <Box mt={20}>
                  <Text color="#565656" size={12} fw={700} opacity={0.5}>
                    Address
                  </Text>
                  <Text size={13} color="#565656" mt={5}>
                    {contact_address}
                  </Text>
                </Box>
                <Box mt={10}>
                  <Text color="#565656" size={12} fw={700} opacity={0.5}>
                    Branch Address
                  </Text>
                  <Text size={13} color="#565656" mt={5}>
                    {branch_address}
                  </Text>
                </Box>
                <Box mt={20}>
                  <Text color="#565656" size={12} fw={700} opacity={0.5}>
                    Email Address
                  </Text>
                  <Text size={13} color="#565656" mt={5}>
                    {contact_email}
                  </Text>
                </Box>
                <Box mt={20}>
                  <Text color="#565656" size={12} fw={700} opacity={0.5}>
                    Phone Number
                  </Text>
                  <Text size={13} color="#565656" mt={5}>
                    {contact_phone}
                    <br />
                    +91 89255 16984
                  </Text>
                </Box>
              </Grid.Col>
              <Grid.Col span={6} md={3} lg={3}>
                <Box
                  style={{
                    borderBottom: '1px solid rgba(238, 238, 238, 0.2)',
                  }}
                  pb={10}
                >
                  <Text color="#565656" fw={600} size={14}>
                    Important Links
                  </Text>
                </Box>
                <Box mt={20}>
                  <Text style={{ cursor: "pointer" }} onClick={() => { navigate('/privacy') }} size={13} color="#565656" mt={5}>
                    Privacy Policy
                  </Text>
                  <Text style={{ cursor: "pointer" }} onClick={() => { navigate('/terms') }} size={13} color="#565656" mt={5}>
                    Terms of Service
                  </Text>
                </Box>
              </Grid.Col>
              <Grid.Col span={6} md={3} lg={3}>
                <Box
                  style={{
                    borderBottom: '1px solid rgba(238, 238, 238, 0.2)',
                  }}
                  pb={10}
                >
                  <Text color="#565656" fw={600} size={14}>
                    Follow us
                  </Text>
                </Box>
                <Box mt={20}>
                  <Flex w={'100%'} wrap={'wrap'}>
                    <ActionIcon mr={15}>
                      <IconBrandFacebook onClick={() => { window.open(link_facebook, '_blank'); }} color="#565656" size={30} />
                    </ActionIcon>
                    <ActionIcon mr={15}>
                      <IconBrandInstagram onClick={() => { window.open(link_instagram, '_blank'); }} color="#565656" size={30} />
                    </ActionIcon>
                    <ActionIcon mr={15}>
                      <IconBrandTwitter onClick={() => { window.open(link_twitter, '_blank'); }} color="#565656" size={30} />
                    </ActionIcon>
                  </Flex>
                </Box>
              </Grid.Col>
            </Grid>
          </Box>
        </Container>
      </footer>
      <Box
        style={{
          background: theme.colors.brand[footer_bg_shade],
          paddingBottom: isMobileScreen ? 80 : 0,
        }}
      >
        <Container size={'xl'} py={20}>
          <Flex justify="space-between" align="center" wrap="wrap">
            <Text color="#565656" size="sm">
              © Quzone 2024. All rights reserved.
            </Text>
            <Text color="#565656" size="xs">
              Made with ❤️ for our valued customers
            </Text>
          </Flex>
        </Container>
      </Box>


    </div>
  );
}

export default AppFooter;
